import { createToast } from 'mosha-vue-toastify';
export class Helper{

  static addZero (i:number):string {
    let strFormattedTime:string;
    (i < 10)?(strFormattedTime = "0" + i):(strFormattedTime = i.toString());
    return strFormattedTime;
  }

  static formatGMT(strTime:string) : string{
    // get gmt
    const time = new Date(strTime);
    const gmt = time.getTimezoneOffset()/60;
    return time.getHours() + ':' + this.addZero(time.getMinutes()) + ` ${ (gmt<0?'+':'-') + (gmt<0?(-gmt):gmt) } GMT`;
  }

  static formatTime(strTime:string) : string{
    const time = new Date(strTime);
    return this.addZero(time.getHours()) + ':' + this.addZero(time.getMinutes());
  }

  static formatDateMonth(strTime:string ) : string{
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const time = new Date(strTime);
    return month[time.getMonth()] + ' ' + time.getDate() + ', ' + time.getFullYear();
  }

  static toCurrencyFormat(value: number, divisibility: number): string {
    const exactValue = value;
    return new Intl.NumberFormat('en', { maximumFractionDigits: divisibility }).format(exactValue);
  }

  static validateEmail(email:string):boolean {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  }

  /* from Sirius wallet */
  static copyToClipboard (data: string): boolean {
    let textInput: HTMLTextAreaElement;

    try {
      textInput = document.createElement('textarea');
      textInput.style.position = 'fixed';
      textInput.value = data;
      document.body.appendChild(textInput);
      textInput.focus();
      textInput.select();

      const range = document.createRange();
      range.selectNodeContents(textInput);

      const textSelection = window.getSelection();
      textSelection.removeAllRanges();
      textSelection.addRange(range);

      textInput.setSelectionRange(0, textInput.value.length);
      document.execCommand('copy');
    } catch (err) {
      console.error(err);
    } finally {
      document.body.removeChild(textInput);
    }
    return true;
  }

  static toastSuccessHandling(responseMessage: any, message?: string): void {
    if (responseMessage && responseMessage !== '') {
      createToast(
        {
          title: "Yay!",
          description: responseMessage ? responseMessage : 'API Success!',
        },
        {
          position: "bottom-right",
          type: "success",
        }
      );
    } else if (message){
      createToast(
        {
          title: "Yay!",
          description: message,
        },
        {
          position: "bottom-right",
          type: "success",
        }
      );
    }
  }

  static endpointErrorHandling(error: any):string{
    let msg: string;
    if(error.message == 'Network Error'){
      msg = 'Network error. Please try again';
      createToast(
        {
          title: "Whoops!",
          description: 'Network error. Please make sure there is network connection',
        },
        {
          position: "bottom-right",
          type: "danger",
        }
      );
    }else{
      msg = error.response.data['message'] ? error.response.data['message']: 'Service is unavailable. Unable to fetch api. Please try again later.';
      createToast(
        {
          title: "Whoops!",
          description: msg,
        },
        {
          position: "bottom-right",
          type: "danger",
        }
      );
    }
    return msg;
  }

  static relativeTime(timeStr: string) {
    const now = new Date();
    const time = new Date(timeStr);
    const seconds = Math.floor((now.getTime()-time.getTime()) / 1000);
    const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    let interval = seconds / 31536000;
    if (interval > 1){
      return time.getDate() + ' ' + month[time.getMonth()] + ' ' + time.getFullYear()
    }
    interval = seconds / 86400;
    if (interval > 1) {
      return Math.floor(interval) + " days ago";
    }
    interval = seconds / 3600;
    if (interval > 1) {
      return Math.floor(interval) + " hours ago";
    }
    interval = seconds / 60;
    if (interval > 1) {
      return Math.floor(interval) + " minutes ago";
    }
    return Math.floor(seconds) + " seconds ago";
  }
}